import script from "./AppFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./AppFooter.vue?vue&type=script&setup=true&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=69e097d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e097d0"]])

export default __exports__